<div class="container-fluid py-5">
  <div class="row">
    <div class="col-md-12">
      <div class="card shadow-sm">
        <div class="card-body p-5">
          <div class="row pb-4">
            <div class="col">
              <h3 class="p-0">HHG Rates Filing Administration</h3>
            </div>
            <div class="col text-right">
							<div class="dropdown">
							  <button type="button" class="btn btn-outline-secondary btn-more w-auto rounded-circle" id="more-options" data-toggle="dropdown" aria-label="More Options" aria-haspopup="true" aria-expanded="false">
									<span class="ellipsis" aria-hidden="true">&#8943;</span>
							  </button>
							  <div class="dropdown-menu dropdown-menu-right">
									<h6 class="dropdown-header text-uppercase px-4">More Options</h6>
							    <a class="dropdown-item" routerLink="/ratefiletspext" routerLinkActive="active">Extend Closing Date</a>
							  </div>
							</div>
            </div>
          </div>

          <div *ngIf="updateSuccessful && (this.rateFileOpenForm.get('rateKind').value === 'Main Rate Filing' || this.rateFileOpenForm.get('rateKind').value === 'Supplemental Rate Filing')" class="alert alert-success">
            Your Rate Filing dates have been successfully updated.
          </div>
          <div *ngIf="updateSuccessful && (this.rateFileOpenForm.get('rateKind').value === 'Rate Effective Dates')" class="alert alert-success">
            Your Rate Effective Dates have been successfully updated.
          </div>
          <div *ngIf="updateSuccessful && (this.rateFileOpenForm.get('rateKind').value === 'TSP Participation')" class="alert alert-success">
            Your TSP Participation dates have been successfully updated.
          </div>
          <div *ngIf="updateFailure" class="alert alert-danger">
            An error has occurred. Please contact support.
          </div>

          <form [formGroup]="rateFileOpenForm" >
            <div class="form-row">
              <div class="form-group col-md-4" *ngIf="this.rateFileOpenForm.get('rateType').value ==='FRT'">
                <label for="rate_kind">Rate Kind</label>
                <select id="rate_kind" class="w-100" formControlName="rateKind"  (change)="changeRateKind($event)">
                  <option value="null">Choose...</option>
                  <option *ngFor="let frtoption of frtOptions" [value]="frtoption.value">{{frtoption.name}}</option>
                </select>
              </div>
              <div class="form-group col-md-4" *ngIf="this.rateFileOpenForm.get('rateType').value ==='HHG'">
                <label for="rate_kind">Rate Kind</label>
                <select id="rate_kind" class="w-100" formControlName="rateKind"  (change)="changeRateKind($event)">
                  <option value="null">Choose...</option>
                  <option *ngFor="let hhgoption of hhgOptions" [value]="hhgoption.value">{{hhgoption.name}}</option>
                </select>
              </div>
            </div>
            <div class="form-row" *ngIf="this.rateFileOpenForm.get('rateType').value !== null && this.rateFileOpenForm.get('rateKind').value !== null">
              <div class="form-group col-md-4">
                <label for="open_date">Open Date</label>
                <input type="text" id="open_date" class="w-100" placeholder="mm/dd/yyyy" 
                             formControlName="openDate" 
                             (bsValueChange)="openDateChange($event)" [minDate]="openMinDate" 
                             [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"
                             [value]="this.rateFileOpenForm.get('openDate').value | date: 'MMM d, y'" 
                             bsDatepicker placement="right"
								
								>
								<div *ngIf="this.rateFileOpenForm.get('openDate').invalid && this.rateFileOpenForm.get('openDate').touched || this.rateFileOpenForm.get('openDate').dirty">
                  <div class="text-danger" *ngIf="this.rateFileOpenForm.get('openDate').hasError('required')">
	                  <span class="fa fa-warning"></span> Open Date is required
                  </div>
                </div>
                
                <div *ngIf="this.rateFileOpenForm.get('openDate').invalid && 
                             this.rateFileOpenForm.get('openDate').touched || 
                             this.rateFileOpenForm.get('openDate').dirty">
                    <div class="text-danger" *ngIf="this.openDateError1">
                      <span class="fa fa-warning"></span> {{openDateErrorMsg1}}
                    </div>
                    <div class="text-danger" *ngIf="this.openDateError2">
                      <span class="fa fa-warning"></span> {{openDateErrorMsg2}}
                    </div>
                </div>
               

              </div>
              <div class="form-group col-md-4">
                <label for="close_date">Close Date</label>
                <input type="text" id="close_date" class="w-100" placeholder="mm/dd/yyyy" 
                formControlName="closeDate" (bsValueChange)="closeDateChange($event)"
                [minDate]="closeMinDate" [value]="this.rateFileOpenForm.get('closeDate').value | date: 'MMM d, y'" 
                [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"
                bsDatepicker [bsConfig]="datePickerConfig" placement="right"
							
								>
                <div *ngIf="this.rateFileOpenForm.get('closeDate').invalid && 
                            this.rateFileOpenForm.get('closeDate').touched || 
                            this.rateFileOpenForm.get('closeDate').dirty">
                  <div class="text-danger" *ngIf="this.rateFileOpenForm.get('closeDate').hasError('required')">
										<span class="fa fa-warning"></span> Close Date is required
                  </div>
                  <div class="text-danger" *ngIf="this.closeDateError1">
                    <span class="fa fa-warning"></span> {{closeDateErrorMsg1}}
                  </div>
                  <div class="text-danger" *ngIf="this.closeDateError2">
                    <span class="fa fa-warning"></span> {{closeDateErrorMsg2}}
                  </div>
                </div>             
              </div>

              <div class="form-group col-md-4" *ngIf="this.rateFileOpenForm.get('rateKind').value === 'Main Rate Filing' || this.rateFileOpenForm.get('rateKind').value === 'Supplemental Rate Filing'">
                <label for="release_to_prod">Release to Production</label>
                <input type="text" id="release_to_prod" class="w-100" 
                [bsConfig]="{containerClass: 'theme-dark-blue', showWeekNumbers: false}"
                placeholder="mm/dd/yyyy" formControlName="releaseDate" [value]="this.rateFileOpenForm.get('releaseDate').value | date: 'MMM d, y'" bsDatepicker [bsConfig]="datePickerConfig" placement="left"
								
								>
								<div *ngIf="this.rateFileOpenForm.get('releaseDate').invalid && this.rateFileOpenForm.get('releaseDate').touched || this.rateFileOpenForm.get('releaseDate').dirty">
                  <div class="text-danger" *ngIf="this.rateFileOpenForm.get('releaseDate').hasError('required')">
                  	<span class="fa fa-warning"></span> Release Date is required
                  </div>
	              </div>
              </div>
						</div>
						<div class="form-row"  *ngIf="this.rateFileOpenForm.get('rateType').value === 'FRT' && this.rateFileOpenForm.get('rateKind').value !== null">
              <div class="form-group col-md-4">
                <label for="bidCycle">Bid Cycle Name</label>
                <input type="text" id="bidCycle" class="w-100" formControlName="bidCycle"		
								>
								<div *ngIf="this.rateFileOpenForm.get('bidCycle').invalid && this.rateFileOpenForm.get('bidCycle').touched || this.rateFileOpenForm.get('bidCycle').dirty">
	                <div class="text-danger" *ngIf="this.rateFileOpenForm.get('bidCycle').hasError('required')">
	                	<span class="fa fa-warning"></span> Bid Cycle Name is required
	                </div>
	              </div>
								<input type="text" class="d-none" formControlName="controlId">
								<input type="text" class="d-none" formControlName="rateKey">
              </div>
            </div>
						<div class="mt-4" *ngIf="(this.rateFileOpenForm.get('openDate').value !== '' || this.rateFileOpenForm.get('closeDate').value !== '' || this.rateFileOpenForm.get('releaseDate').value !== '') && this.rateFileOpenForm.get('rateType').value !== null && this.rateFileOpenForm.get('rateKind').value !== null">
              <div class="mt-4">
                <button type="button" class="btn btn-primary w-auto" [disabled]="this.rateFileOpenForm.invalid || this.updateSuccessful || this.buttonDisable || this.validationError" (click)="SaveRateFileRec()">Save</button>
                <button type="button" class="btn btn-outline-secondary w-auto ml-4 " [disabled]="(this.rateFileOpenForm.get('openDate').value === '' || this.rateFileOpenForm.get('closeDate').value === '' || this.rateFileOpenForm.get('releaseDate').value === '')" (click)="clearPage()">Cancel</button>
                <button type="button" class="btn btn-primary w-auto ml-4 " (click)="goBack()">Back</button>
              </div>
						</div>
					</form>
				</div>
			</div>
			<div class="card shadow-sm mt-5" *ngIf="this.rateFileOpenForm.get('rateType').value !== null && this.rateFileOpenForm.get('rateKind').value !== null">
        <div class="card-body p-5">
        	<table class="table table-striped">
            <thead>
              <tr>
                <th>Open Date</th>
                <th>Close Date</th>
                <th *ngIf="this.rateFileOpenForm.get('rateKind').value === 'Main Rate Filing' || this.rateFileOpenForm.get('rateKind').value === 'Supplemental Rate Filing'">Release to Production</th>
                <th *ngIf="this.rateFileOpenForm.get('rateType').value === 'FRT'">Bid Cycle Name</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let rateFileDetail of rateFileDetails; let i = index;">
                <!--
              	<td *ngIf = "i == 0"><a  [routerLink]="" (click)="selectedRecord(rateFileDetail.controlId, i)">{{rateFileDetail.effectiveDate | date: 'M/d/y'}}</a></td>
                <td *ngIf = "i != 0">{{rateFileDetail.effectiveDate | date: 'M/d/y'}}</td>
                -->
                <td><a  [routerLink]="[]"  (click)="selectedRecord(rateFileDetail.controlId, i)"
                        >{{rateFileDetail.effectiveDate | date: 'M/d/y'}}</a></td> 
                <td>{{rateFileDetail.expiryDate | date: 'M/d/y'}}</td>
                <td *ngIf="this.rateFileOpenForm.get('rateKind').value === 'Main Rate Filing' || this.rateFileOpenForm.get('rateKind').value === 'Supplemental Rate Filing'">{{rateFileDetail.releaseDate | date: 'M/d/y'}}</td>
                <td *ngIf="this.rateFileOpenForm.get('rateType').value === 'FRT'">{{rateFileDetail.cycleName}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

